<template>
    <div>
      
    </div>
</template>

<script>
// import mqtt from 'mqtt'
// import { MQTT_SERVICE, MQTT_USERNAME, MQTT_PASSWORD } from './sysconstant.js'
var client;
export default {
  name: 'Mqtt',
  props:['imei','server_url'],
  data () {
    return {
      msg: '',
      myimei:'',
      sendmsg:'',
      times:1,
      in_times:1,
      timeid:[],
      machineStatus:"N",
      er_msg: ''
    }
  },
  created () {
    // this.testOnLine()
  },
  methods: {
    testOnLine(imei){
      var url = this.server_url+"/server/c/testOnline/?imei="+this.imei
      this.axios.get(url)
      .then((res) =>{
        console.log(res)
        if(res.data.code === 2000){
          if(this.machineStatus == "N"){
            this.machineStatus = "on";
          }
          this.$emit("machineStatus","on")
        }else{
          this.machineStatus = "off";
          this.$emit("machineStatus","off",res.data.msg)
        }
      })
      .catch((error)=>{
        this.$emit("machineStatus","off",error)
      })
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Mqtt/Mqtt.vue